import React from "react";

const GroupSexRoomFuckLineOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71.045"
      height="233.386"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 71.045 233.386"
      xmlSpace="preserve"
      className='clickable object-glow'
    >
      <g
        transform="translate(-229.025 -1854.533)"
        fill='rgba(0,0,0,0)'
        className='object-glow'
      >
        <g fill="#ff5c97" stroke="none" opacity="1">
          <path d="M274.969 2029.15c.4 0 .761-.32.764-.76l.085-13.84a.753.753 0 00-.755-.76l-1.16-.01c-.4 0-.762.31-.765.75l-.071 11.52-24.559-.15c-.4 0-.762.36-.765.76l-.009 1.56c-.003.44.355.76.755.76z"></path>
          <path d="M265.523 2010.41c6.08.03 10.746-4.22 10.785-10.5.038-6.32-4.575-10.67-10.655-10.7l-16.92-.11c-.4 0-.762.36-.764.76l-.009 1.52c-.003.44.355.76.755.76l16.76.11c4.559.02 8.022 2.93 7.993 7.65-.029 4.68-3.606 7.49-8.166 7.47l-16.68-.11c-.4 0-.762.32-.764.76l-.01 1.52c-.002.4.356.76.756.76z"></path>
          <path d="M275.261 1981.47c.4 0 .762-.32.764-.76l.056-9.12c.032-5.16-3.186-8.74-7.666-8.77-3.68-.02-5.656 2.65-6.549 4.76-1.069-1.88-3.296-3.94-6.376-3.96-4.2-.02-7.38 3.28-7.41 8.16l-.054 8.76c-.003.44.355.76.755.76zm-14.662-3.09l-9.799-.06.04-6.52c.018-3.08 1.949-4.79 4.829-4.77 2.8.01 4.989 1.75 4.97 4.83zm12.76.15l-10-.06.04-6.6c.019-3.12 2.115-5.7 4.955-5.69 2.88.02 5.067 2.15 5.049 5.07z"></path>
          <path d="M275.414 1956.47c.4 0 .762-.32.765-.76l.096-15.76a.753.753 0 00-.755-.76l-1.16-.01c-.4 0-.762.32-.765.76l-.082 13.43-10.2-.06.071-11.48a.755.755 0 00-.756-.76l-1.16-.01c-.4 0-.762.36-.764.76l-.071 11.48-9.76-.06.083-13.44a.764.764 0 00-.756-.77l-1.16-.01c-.4 0-.761.32-.764.76l-.097 15.76c-.002.44.356.76.756.76z"></path>
        </g>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M251.3 1863.4c-1.4 4.67-2.1 9.57-2.1 14.7 0 5.13.467 8.17 1.4 9.1.467.47.933.93 1.4 1.4-1.4.47-2.8.93-4.2 1.4-2.8.93-5.6 2.8-8.4 5.6-2.8 2.8-4.9 5.83-6.3 9.1-1.4 3.27-1.867 31.97-1.4 86.1.467 54.13 1.633 82.6 3.5 85.4 1.867 2.8 4.433 4.9 7.7 6.3 3.267 1.4 9.567 2.33 18.9 2.8 9.333.47 16.8-.47 22.4-2.8 5.6-2.33 9.1-4.9 10.5-7.7 1.4-2.8 2.333-31.27 2.8-85.4.467-54.13-1.4-84-5.6-89.6-4.2-5.6-8.576-10.35-11.376-11.28-1.439-.48 1.011-.79 1.81-2.95.976-2.65-.344-8.72-.118-13.71.234-5.13-.604-8.43-4.658-12.13-4.054-3.69-7.358-2.4-11.558-2.63-8.4-.47-13.3 1.63-14.7 6.3z"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M251.429 1888.34c-.011 0 7.404 2.1 13.921 2.15 6.516.05 15.172-2.9 15.242-2.76"
          opacity="1"
        ></path>
        <path
          fill="none"
          stroke="#ff5c97"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M241.448 1924.08h41.56v120.71h-41.56z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default GroupSexRoomFuckLineOutline;